module.exports = __webpack_public_path__ + "img/up-danger.014b3822.svg";